import { Box, Skeleton, Typography } from '@mui/material';

export const LoadingProjectCard = () => {
    return (
        <Box width={'100%'}>
            <Skeleton variant='rounded' width='100%' height={150} />

            <Typography variant='subtitle2'>
                <Skeleton width='50%' animation='wave' />
            </Typography>

            <Typography variant='h5'>
                <Skeleton width='70%' animation='wave' />
            </Typography>

            <Typography variant='body2'>
                <Skeleton width='90%' animation='wave' />
            </Typography>

            <Box gap={1} mt={1} style={{ display: 'flex' }}>
                {Array.from({ length: 2 }).map((_, index) => (
                    <Skeleton
                        key={index}
                        variant='rounded'
                        width={100}
                        height={20}
                        animation='wave'
                    />
                ))}
            </Box>
        </Box>
    );
};
